import { render } from "./Playlists.vue?vue&type=template&id=3ba021a2"
import script from "./Playlists.vue?vue&type=script&lang=js"
export * from "./Playlists.vue?vue&type=script&lang=js"

import "./Playlists.vue?vue&type=style&index=0&id=3ba021a2&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__